module.exports = __webpack_public_path__ + "static/media/Team 4 Refashion - Udinov Alexandra.bd791701.png";